import { render, staticRenderFns } from "./sign-attribute-badge.vue?vue&type=template&id=4eb20b2c&scoped=true&"
import script from "./sign-attribute-badge.vue?vue&type=script&lang=ts&"
export * from "./sign-attribute-badge.vue?vue&type=script&lang=ts&"
import style0 from "./sign-attribute-badge.vue?vue&type=style&index=0&id=4eb20b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb20b2c",
  null
  
)

export default component.exports